import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { FindSharedEntityByEntityParams } from '../../../modules/shared-entities/types/sharedEntities.types';
import { FindSharedEntityParams } from './sharedEntities.types';

export const getFindSharedEntitiesKey = (
  params: FindSharedEntityParams,
): UseDataQuery['queryKey'] => ['shared-entities', undefined, params ?? {}];

export const getFindSharedEntityByEntityKey = (
  params: FindSharedEntityByEntityParams,
): UseDataQuery['queryKey'] => ['shared-entities', 'by-entity', params ?? {}];
